// @flow
import * as React from 'react';
import {connect} from 'react-redux';
import classNames from 'classnames';
import {withStyles} from '@material-ui/core/styles';
import api from 'utils/API';
import Icon from 'app/components/Icon';
import styles from './CommentModeratorActions.styles.js';

type Props = {
  classes: any,
  postId: number,
  commentId: number,
  author: string
};

type State = {
  status: number
};

class CommentModeratorActions extends React.Component<Props, State> {
  constructor(props) {
    super(props);

    const initData = props.initData || {};

    this.state = {
      status: Number(initData.status)
    };
  }

  send = (commentId, action) => {
    const url = `/comments/${action}`;
    const data = {id: commentId};
    api.post(url, data)
    .then(response => {
      const data = response.data;
      this.setState({
        status: Number(data.status) || 0
      });
    });
  }

  render() {
    const {classes, commentId} = this.props;
    const approveSelected = this.state.status === 1;
    const rejectSelected = this.state.status === 2;
    return (
      <div>
        <span
          className={classNames(classes.item, classes.unknown)}
          onClick={() => this.send(commentId, 'unknown')}
        >
          {/* <Icon className={classes.itemIcon} name="approve" /> */}
          تعیین نشده
        </span>

        <span
          className={classNames(classes.item, classes.approve, {selected: approveSelected})}
          onClick={() => this.send(commentId, 'approve')}
        >
          <Icon className={classes.itemIcon} name="thumb_up" />
          پذیرش
        </span>

        <span
          className={classNames(classes.item, classes.reject, {selected: rejectSelected})}
          onClick={() => this.send(commentId, 'reject')}
        >
          <Icon className={classes.itemIcon} name="thumb_down" />
          عدم پذیرش
        </span>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  commentReply: state.commentReply
});

const Component = connect(mapStateToProps)(withStyles(styles)(CommentModeratorActions));
export {Component as CommentModeratorActions};
export default Component;